import { render, staticRenderFns } from "./BonusListScreen.vue?vue&type=template&id=a56fcbc8&"
import script from "./BonusListScreen.vue?vue&type=script&lang=js&"
export * from "./BonusListScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports